import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useColors from "../api/hooks/useColors";
import SvgToIcon from "../icons/SvgToIcon";
import { ReactComponent as Done } from "../icons/icon_files/done.svg";
import { ReactComponent as Error } from "../icons/icon_files/error.svg";
import LoadingIcon from "./LoadingIcon";

export const operationStatus = {
  LOADING: "Loading",
  SUCCESS: "Success",
  ERROR: "Error",
};

const ActionStatus = ({ status, setStatus }) => {
  const colors = useColors();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (status === operationStatus.LOADING) {
      setVisible(true);
    } else if (status === operationStatus.SUCCESS) {
      const timer1 = setTimeout(() => {
        setVisible(false);
        const timer2 = setTimeout(() => {
          setStatus(null);
          setVisible(false);
        }, 500);
        return () => clearTimeout(timer2);
      }, 4000);
      return () => clearTimeout(timer1);
    }
  }, [status]);

  return (
    <Box
      display="flex"
      gap={1}
      style={{
        opacity: visible ? 1 : 0,
        transition: "opacity 0.5s ease-in-out",
      }}
      alignItems="center"
    >
      <Box>
        {status === operationStatus.LOADING ? (
          <LoadingIcon size={15} />
        ) : status === operationStatus.SUCCESS ? (
          <SvgToIcon IconLogo={Done} width={12} />
        ) : status === operationStatus.ERROR ? (
          <SvgToIcon IconLogo={Error} width={12} />
        ) : null}
      </Box>
      {status === operationStatus.SUCCESS ? (
        <Box display="flex" alignItems="center">
          <Typography variant="smallCaption" color={colors.text_primary}>
            Saved
          </Typography>
        </Box>
      ) : status === operationStatus.ERROR ? (
        <Box display="flex" alignItems="center">
          <Typography variant="smallCaption" color={colors.text_primary}>
            Saving failed. Please try again later
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
};

export default ActionStatus;
